export default __webpack_public_path__ + "static/media/projectone.d1f2a98b.jpg";